import { render, staticRenderFns } from "./SourceBadge.vue?vue&type=template&id=79514da3&scoped=true&"
import script from "./SourceBadge.vue?vue&type=script&lang=js&"
export * from "./SourceBadge.vue?vue&type=script&lang=js&"
import style0 from "./SourceBadge.vue?vue&type=style&index=0&id=79514da3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79514da3",
  null
  
)

export default component.exports